import { render, staticRenderFns } from "./wxlogin.vue?vue&type=template&id=9da4217e&scoped=true&"
import script from "./wxlogin.vue?vue&type=script&lang=js&"
export * from "./wxlogin.vue?vue&type=script&lang=js&"
import style0 from "./wxlogin.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./wxlogin.vue?vue&type=style&index=1&id=9da4217e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da4217e",
  null
  
)

component.options.__file = "wxlogin.vue"
export default component.exports